import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const getFeedbackCategoriesReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_GET_FEEDBACK_CATEGORIES:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_GET_FEEDBACK_CATEGORIES_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_GET_FEEDBACK_CATEGORIES_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_GET_FEEDBACK_CATEGORIES:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default getFeedbackCategoriesReducer;
